<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    v-dialog(v-model='dialog6', persistent max-width='1000px')
      v-card
        v-card-text
          v-container(id="printJS-form2")
            div(align='center')
              h5(style='font-weight: 400 !important;') COBROS
            div(align='center')
              img(src='../assets/logo.png', style='width: 200px;margin-top: -20px;margin-bottom: -15px;')
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Nro
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.nro}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Fecha
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.fechaC | moment('DD/MM/YYYY H:mm A')}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Método de pago
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.metodo}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Vendedor
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.vendedor}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Cliente
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.cliente.cli_des}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Titular
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.titular') {{form.titular}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Titular rif
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.rifTitular') {{form.rifTitular}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Facturas
                td.withTd2(align='center' style="padding:0px;")
                  div(v-for='item in (itemsF && itemsF.length > 0 ? itemsF : form.facturas)')
                    b {{ item.text ? item.text : item }}
              tr(v-if="form.tasa")
                td.withTd2(align='center' style="padding:0px;")
                  b Tasa
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.tasa}}BS
              tr(v-if="form.tasaIva")
                td.withTd2(align='center' style="padding:0px;")
                  b Tasa I.V.A.
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.tasaIva}}BS
              tr(v-if="form.base")
                td.withTd2(align='center' style="padding:0px;")
                  b Base
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.moneda == "BS" && form.tasa') ${{transformMonto(form.base, form.tasa)}} ({{form.base}}BS)
                  b(v-if='form.moneda == "BS" && !form.tasa') {{form.base}}BS
                  b(v-if='form.moneda == "US$"') ${{form.base}}
              tr(v-if="form.iva")
                td.withTd2(align='center' style="padding:0px;")
                  b Iva
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.moneda == "BS" && form.tasaIva') ${{transformMonto(form.iva, form.tasaIva)}} ({{form.iva}}BS)
                  b(v-if='form.moneda == "BS" && !form.tasaIva') {{form.iva}}BS
                  b(v-if='form.moneda == "US$"') ${{form.iva}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Total
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.moneda == "BS" && form.tasa') ${{transformMontoG(form)}} ({{form.monto}}BS)
                  b(v-if='form.moneda == "BS" && !form.tasa') {{form.monto}}BS
                  b(v-if='form.moneda == "US$"') ${{form.monto}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Referencia
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.referencia') {{form.referencia}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Observación
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.observacion') {{form.observacion}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Descripción
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.descripcion') {{form.descripcion}}
                  b(v-else) N/A
            div(v-if='form.bauche' style="display: flex;justify-content: center;margin-top:20px;")
              img(:src='ruta + form.bauche' style='width: auto;height: 600px;object-fit:contain;')
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close4()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf2()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog3', persistent max-width='85%')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(align='center')
              h5(style='font-weight: 400 !important;text-decoration: underline;' v-if='dates && dates.length > 0') COBROS {{dates[0]}} - {{dates[1]}}
            br
            table(border="0" align="center" style='width: 100%;')
              tr
                td(align='center').withTd2
                  b N°
                td(align='center').withTd2
                  b FECHA
                td(align='center' style="line-height: 16px;").withTd2
                  b FECHA PAGO
                td(align='center').withTd2
                  b VENDEDOR
                td(align='center').withTd2
                  b CLIENTE
                td(align='center').withTd2
                  b METODO
                td(align='center').withTd2
                  b TIPO
                td(align='center').withTd2
                  b TASA
                td(align='center').withTd2
                  b TASA I.V.A.
                td(align='center').withTd2
                  b BASE
                td(align='center').withTd2
                  b IVA
                td(align='center').withTd2
                  b TOTAL
                td(align='center').withTd2
                  b REFERENCIA
                td(align='center').withTd2
                  b DESCRIPCIÓN
                td(align='center').withTd2
                  b ESTATUS
              tr(v-for='item in resultados')
                td(align='center').withTd2
                  b {{item.nro}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.fechaC | moment('DD/MM/YYYY H:mm A')}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.fechaP | moment('DD/MM/YYYY H:mm A')}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.vendedor}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.cliente.cli_des}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.metodo}}
                td(align='center' style="line-height: 16px;").withTd2
                  b(v-if="item.tipo") {{item.tipo}}
                  b(v-else) N/A
                td(align='center' style="line-height: 16px;").withTd2
                  b(v-if="item.tasa") {{item.tasa}}
                  b(v-else) N/A
                td(align='center' style="line-height: 16px;").withTd2
                  b(v-if="item.tasaIva") {{item.tasaIva}}
                  b(v-else) N/A
                td(align='center').withTd2
                  b(v-if='item.base && item.moneda == "BS" && item.tasa') ${{transformMonto(item, item.base, item.tasa)}} ({{item.base}}BS)
                  b(v-if='item.base && item.moneda == "BS" && !item.tasa') {{item.base}}BS
                  b(v-if='item.base && item.moneda == "US$"') ${{item.base}}
                  b(v-if='!item.base') N/A
                td(align='center').withTd2
                  b(v-if='item.iva && item.moneda == "BS" && item.tasaIva') ${{transformMonto(item.iva, item.tasaIva)}} ({{item.iva}}BS)
                  b(v-if='item.iva && item.moneda == "BS" && !item.tasaIva') {{item.iva}}BS
                  b(v-if='item.iva && item.moneda == "US$"') ${{item.iva}}
                  b(v-if='!item.iva') N/A
                td(align='center').withTd2
                  b(v-if='item.moneda == "BS" && item.tasa') ${{transformMontoG(item)}} ({{item.monto}}BS)
                  b(v-if='item.moneda == "BS" && !item.tasa') {{item.monto}}BS
                  b(v-if='item.moneda == "US$"') ${{item.monto}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.referencia}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.descripcion}}
                td(align='center').withTd2
                  b {{item.estatus}}
                  br(v-if='esMetodoP2(item.metodo) && item.estatus2')
                  b(v-if='esMetodoP2(item.metodo) && item.estatus2' style="color:#1976d2;") {{item.estatus2}}

        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog7', persistent max-width='1000px')
          v-container(style='background-color:white !important;max-width: 1000px;')
            v-card-title.justify-center
              span.headline Cobro
            div(style="margin-top: 10px;" v-if='itemMov')
              v-flex(xs12, sm12, md12)
                v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
                  v-flex(xs4 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Nro:
                      span {{itemMov.nro}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha:
                      span {{transform2(itemMov.fechaC)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha de pago:
                      span {{transform(itemMov.fechaP)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Moneda:
                      span(v-if='!itemMov.moneda') N/A
                      span(v-else) {{itemMov.moneda}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Tasa B.:
                      span(v-if='itemMov.tasa') {{itemMov.tasa}}
                      span(v-else) N/A
                  v-flex(xs5 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Tasa I.:
                      span(v-if='itemMov.tasaIva') {{itemMov.tasaIva}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Valija:
                      span {{itemMov.nroValija}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Vendedor:
                      span {{itemMov.vendedor}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Cliente:
                      span(v-if='itemMov.clienteN') {{itemMov.clienteN}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Rif Titular:
                      span(v-if='itemMov.rifTitular') {{itemMov.rifTitular}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Método:
                      span {{itemMov.metodo}}
                  v-flex(xs3 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Monto:
                      span(v-if='itemMov.moneda == "BS" && itemMov.tasa') ${{ transformMontoG(itemMov) }} ({{itemMov.monto}}BS)
                      span(v-if='itemMov.moneda == "BS" && !itemMov.tasa') {{itemMov.monto}}BS
                      span(v-if='itemMov.moneda == "US$"') ${{itemMov.monto}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Tipo:
                      span(v-if='itemMov.tipo') {{itemMov.tipo}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Referencia:
                      span(v-if='itemMov.referencia') {{itemMov.referencia}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Cobro:
                      span(v-if='itemMov.nroCobro') {{itemMov.nroCobro}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Estatus:
                      span {{itemMov.estatus}}
            v-card-title.justify-center
              span.headline Posibles movimientos asociados
            div(style="margin-top: 10px;")
              v-flex(xs12, sm12, md12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-flex(xs12)
                    v-form(enctype="multipart/form-data")

                      v-data-table.elevation-1(v-model="selectMov" :single-select="true" item-key="_id" :headers='headersMov' :pagination.sync="paginationMov" :items="resultadosMov" style="margin-top: 5px;")
                        template(slot='items', slot-scope='props')
                          td
                            v-checkbox(
                              :value='props.item'
                              style='margin: 0px;padding: 0px;'
                              hide-details=''
                              v-model="selectMov"
                            )
                          td {{ transform(props.item.fecha)}}
                          td {{ props.item.descripcion }}
                          td {{ props.item.banco }}
                          td {{ props.item.monto }}
                          td {{ props.item.referencia }}
                          td {{ props.item.estatus }}

                      div
                        v-flex(v-if="loading === true", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-progress-circular(indeterminate='', color='primary')
                        v-flex(v-if="loading === false", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                              v-btn(v-if='selectMov && selectMov.length > 0' style="background:green;border-radius:10px;", @click.native='editItemAproMov') Guardar
                              v-btn(style="background:black;border-radius:10px;", @click.native='closeMov') Salir
    v-dialog(v-model='dialog8', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:green;border-radius:10px;", @click.native='saveRef') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='closeRef') Salir
    v-dialog(v-model='dialog9', persistent max-width='500px')
          v-container(style='background-color:white !important;max-width: 500px;')
            v-card-title.justify-center
                span.headline Fecha Pago
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                          v-menu(ref='menu2' v-model='modal2' :close-on-content-click='false' transition='scale-transition' offset-y='')
                            template(v-slot:activator='{ on, attrs }')
                              v-text-field(outline v-model='dateFormatted' label='Fecha' persistent-hint='' v-bind='attrs' @blur='form.fechaP = parseDate(dateFormatted)' v-on='on')
                            v-date-picker(v-model='form.fechaP' no-title='' @input='modal2 = false' dark='')

                          div
                            v-flex(v-if="loading === true", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                v-progress-circular(indeterminate='', color='primary')
                            v-flex(v-if="loading === false", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-btn(style="background:green;border-radius:10px;", @click.native='saveFecha') Guardar
                                  v-btn(style="background:black;border-radius:10px;", @click.native='close9') Salir
    v-dialog(v-model='dialog5', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-if='form.base'
                            v-model="form.base"
                            type='number'
                            prepend-inner-icon="description"
                            label="Base:")
                            
                            v-text-field(outline
                            v-if='form.iva'
                            v-model="form.iva"
                            type='number'
                            prepend-inner-icon="description"
                            label="IVA:")
                            
                            v-text-field(outline
                            v-if='form.tasa'
                            type='number'
                            v-model="form.tasa"
                            prepend-inner-icon="description"
                            label="Tasa Base:")
                            
                            v-text-field(outline
                            v-if='form.tasaIva'
                            type='number'
                            v-model="form.tasaIva"
                            prepend-inner-icon="description"
                            label="Tasa Iva:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:green;border-radius:10px;", @click.native='saveMonto') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='closeMonto') Salir
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.metodo"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-text-field(outline
                            v-if='form.rifTitular'
                            readonly
                            v-model="form.rifTitular"
                            prepend-inner-icon="description"
                            label="Titular rif:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            item-value="value"
                            item-text="text"
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")

                            v-text-field(outline
                            v-if='facturaFiscalTexto'
                            readonly
                            :value="facturaFiscalTexto"
                            prepend-inner-icon="receipt"
                            label="Factura Fiscal:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.tasa"
                            v-if='form.tasa'
                            prepend-inner-icon="description"
                            label="Tasa:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.tasaIva"
                            v-if='form.tasaIva'
                            prepend-inner-icon="description"
                            label="Tasa I.V.A.:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.base"
                            v-if='form.base'
                            prepend-inner-icon="description"
                            label="Base:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.iva"
                            v-if='form.iva'
                            prepend-inner-icon="description"
                            label="Iva:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Total:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.nroCobro'
                              v-model="form.nroCobro"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de cobro:")

                            v-text-field(outline
                              v-if='form.nroCobro2'
                              v-model="form.nroCobro2"
                              readonly
                              style='color:blue;'
                              prepend-inner-icon="description"
                              label="Nro. de cobro (secundario):")

                            v-text-field(outline
                              v-if='form.nroAJNM'
                              v-model="form.nroAJNM"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de AJNM:")

                            v-text-field(outline
                              v-if='form.nroADEL'
                              v-model="form.nroADEL"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de ADEL:")

                            v-text-field(outline
                              v-if='form.nroNI'
                              v-model="form.nroNI"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de NI:")

                            v-text-field(outline
                              v-if='form.referencia'
                              v-model="form.referencia"
                              prepend-inner-icon="description"
                              label="Referencia:")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='form.estatus === "Aprobado" || form.estatus === "Conciliado"' style="background:green;border-radius:10px;", @click.native='save("P")') Procesado
                                    v-btn(v-if='(form.estatus === "Aprobado" || form.estatus === "Conciliado" || form.estatus === "Procesado") && !form.procesado2 && esMetodoP2(form.metodo)' style="background:blue;border-radius:10px;", @click.native='save("P2")') Procesar 2
                                    v-btn(v-if='form.estatus === "Pendiente" ' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(v-if='form.estatus === "Conciliado"' style="background:purple;border-radius:10px;", @click.native='save("F")') Finalizar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs3)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='aplicarFiltros()')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='metodos' v-model="seleccionFiltroM" label="Métodos" @change='aplicarFiltros()')
            v-flex(xs3 style='display: flex;align-items: center;justify-content: flex-end;')
              //- v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              //-   template(v-slot:activator='{ on, attrs }')
              //-     v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
              //-   v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ff6500' style='font-size: 1.70rem;') search
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Fercoven-Cobros'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span Cobros
              vue-excel-xlsx( v-if='resultados2 && resultados2.length > 0' :data='dataExcel2' :columns='columnsExcel2' :filename="'Fercoven-Cobros-Vendedores'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span T.C.V
              a(style='margin-right: 12px;' @click="dialog3 = true")
                img(src='../assets/pdf.svg', style="height: 60px;width: auto;object-fit: contain;")
            v-flex(xs12 v-if='selected.length > 0')
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-btn(v-if='selected[0].estatus === "Aprobado" || selected[0].estatus === "Conciliado"' style="background:green;border-radius:10px;", @click.native='saveAll("P")') Procesar
                v-btn(v-if='(selected[0].estatus === "Aprobado" || selected[0].estatus === "Conciliado" || selected[0].estatus === "Procesado") && selected.some(el => !el.procesado2 && esMetodoP2(el.metodo))' style="background:blue;border-radius:10px;", @click.native='saveAll("P2")') Procesar 2
                //- v-btn(v-if='selected[0].estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='saveAll("A")') Aprobar
                v-btn(v-if='selected[0].estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='saveAll("R")') Rechazar
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(v-model="selected" :single-select="false" item-key="nro" ref='tablet1' :headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" :custom-filter="filterPerfectMatch" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td 
              v-checkbox(
                :value='props.item'
                v-if="props.item.estatus == 'Pendiente' || props.item.estatus == 'Conciliado' || props.item.estatus == 'Aprobado' || (props.item.estatus == 'Procesado' && !props.item.procesado2 && esMetodoP2(props.item.metodo))"
                style='margin: 0px;padding: 0px;'
                hide-details=''
                v-model="selected"
              )
            td {{ props.item.nro}}
            td(v-if='props.item.groupCobro') {{ props.item.groupCobro}}
            td(v-else) N/A
            td {{ transform2(props.item.fechaC)}}
            td {{ transform(props.item.fechaP)}}
            td(v-if='!props.item.moneda') N/A
            td(v-else) {{props.item.moneda}}
            td(v-if='props.item.tasa') {{ props.item.tasa }}
            td(v-else) N/A
            td(v-if='props.item.tasaIva') {{ props.item.tasaIva }}
            td(v-else) N/A
            td {{ props.item.nroValija }}
            td {{ props.item.vendedor }}
            td(v-if='props.item.clienteN') {{ props.item.clienteN }}
            td(v-else) N/A
            td {{ props.item.metodo }}
            td(v-if='props.item.moneda == "BS" && props.item.tasa') ${{ transformMontoG(props.item) }} ({{props.item.monto}}BS)
            td(v-if='props.item.moneda == "BS" && !props.item.tasa') {{props.item.monto}}BS
            td(v-if='props.item.moneda == "US$"') ${{props.item.monto}}
            td(v-if='props.item.tipo') {{props.item.tipo}}
            td(v-else) N/A
            td(v-if='props.item.referencia') {{ props.item.referencia}}
            td(v-else) N/A
            td(v-if='props.item.nroCobro || props.item.nroCobro2')
              div(v-if='props.item.nroCobro') {{ props.item.nroCobro }}
              div(v-if='props.item.nroCobro2' style='color:blue;') {{ props.item.nroCobro2 }}
            td(v-else) N/A
            td
              div {{ props.item.estatus }}
              div(v-if='esMetodoP2(props.item.metodo) && props.item.estatus2' style='color:blue;') {{ props.item.estatus2 }}
            td.justify-center.layout.px-0
              v-layout(wrap)
                v-flex(xs4 v-if='mod')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') edit
                    | Editar.
                v-flex(xs4  v-if='mod && (props.item.estatus === "Pendiente" || props.item.estatus === "Aprobado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemReferencia(props.item)' v-on="on" color='orange') description
                    | Editar Referencia.
                v-flex(xs4  v-if='mod && (props.item.estatus === "Pendiente" || props.item.estatus === "Aprobado" || props.item.estatus === "Conciliado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemMonto(props.item)' v-on="on" color='teal') description
                    | Editar Monto.
                v-flex(xs4  v-if='mod && props.item.estatus === "Pendiente"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemFecha(props.item)' v-on="on" color='teal') description
                    | Editar Fecha P.
                v-flex(xs4)
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemPdf(props.item)' v-on="on" color='red') description
                    | PDF
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo == "Efectivo"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "A")' v-on="on" color='teal') check_circle
                    | Aprobar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo !== "Efectivo" && !props.item.coincide')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="blue") description
                    | Conciliar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo !== "Efectivo" && props.item.coincide')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="black") description
                    | Conciliar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Conciliado" && props.item.tipo == "IVA"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='registrarIVA(props.item)' v-on="on" color="purple") description
                    | Registrar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "R")' v-on="on" color='red') cancel
                    | Rechazar.
                v-flex(xs4 v-if='mod && (props.item.estatus == "Aprobado" || props.item.estatus == "Conciliado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "P")' v-on="on" color='teal') cloud
                    | Procesar.
                v-flex(xs4 v-if='mod && (props.item.estatus == "Aprobado" || props.item.estatus == "Conciliado" || props.item.estatus == "Procesado") && !props.item.procesado2 && esMetodoP2(props.item.metodo)')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "P2")' v-on="on" color='blue') cloud_queue
                    | Procesar 2.
                v-flex(xs4 v-if='mod && props.item.estatus == "Conciliado"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='reversarConciliacion(props.item)' v-on="on" color='teal') undo
                    | Reversar Conciliación.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import printJS from 'print-js'
export default {
  name: "Cobros",
  data: vm => ({
    selected: [],
    json_data: [],
    itemMov: null,
    typeMov: null,
    selectMov: [],
    resultadosMov: [],
    resultadosMovAll: [],
    dialog3: false,
    dialog5: false,
    dialog6: false,
    dialog7: false,
    dialog8: false,
    dialog9: false,
    ruta: serverImg,
    dates: [],
    loading: false,
    dialog4: false,
    seleccionFiltro: 'todos',
    seleccionFiltroM: 'todos',
    metodos: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Zelle",
        value: "Zelle"
      },
      {
        text: "Transferencia Internacional Banesco Panamá",
        value: "Transferencia Internacional Banesco Panamá"
      },
      {
        text: "Transferencia Nacional Banesco",
        value: "Transferencia Nacional Banesco"
      },
      {
        text: "Transferencia Nacional Mercantil",
        value: "Transferencia Nacional Mercantil"
      },
      {
        text: "Transferencia Nacional Provincial",
        value: "Transferencia Nacional Provincial"
      },
      {
        text: "Transferencia Nacional Bancaribe",
        value: "Transferencia Nacional Bancaribe"
      },
      {
        text: "Transferencia Nacional GT Mercantil",
        value: "Transferencia Nacional GT Mercantil"
      },
      {
        text: "Transferencia Nacional GT Venezuela",
        value: "Transferencia Nacional GT Venezuela"
      },
      {
        text: "Transferencia Nacional GT Bancaribe",
        value: "Transferencia Nacional GT Bancaribe"
      },
      {
        text: "Transferencia Nacional GT Provincial",
        value: "Transferencia Nacional GT Provincial"
      },
      {
        text: "Efectivo",
        value: "Efectivo"
      },
      {
        text: "Binance",
        value: "Binance"
      },
      {
        text: "MPCVault",
        value: "MPCVault"
      },
    ],
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Conciliados",
        value: "Conciliado"
      },
      {
        text: "Registrados",
        value: "Registrado"
      },
      {
        text: "Aprobados",
        value: "Aprobado"
      },
      {
        text: "Rechazados",
        value: "Rechazado"
      },
      {
        text: "Procesados",
        value: "Procesado"
      },
      {
        text: "Finalizados",
        value: "Finalizado"
      },
    ],
    itemsF: [],
    dataExcel: [],
    dataExcel2: [],
    resultados2: [],
    columnsExcel2: [
      {
        label: "Fecha inicial",
        field: "fecha",
      },
      {
        label: "Código",
        field: "co_ven",
      },
      {
        label: "Vendedor",
        field: "ven_des",
      },
      {
        label: "Total efectivo",
        field: "total",
      },
    ],
    columnsExcel: [
      {
        label: "N° Web",
        field: "nro",
      },
      {
        label: "Fecha",
        field: "fechaC",
      },
      {
        label: "Fecha de pago",
        field: "fechaP",
      },
      {
        label: "Moneda",
        field: "moneda",
      },
      {
        label: "Tasa Base",
        field: "tasa",
      },
      {
        label: "Tasa IVA",
        field: "tasaIva",
      },
      {
        label: "N° Valija",
        field: "nroValija",
      },
      {
        label: "Vendedor",
        field: "vendedor",
      },
      {
        label: "Cliente",
        field: "cliente",
      },
      {
        label: "Método",
        field: "metodo",
      },
      {
        label: "Tipo",
        field: "tipo",
      },
      {
        label: "Base $",
        field: "base",
      },
      {
        label: "Base BS",
        field: "baseBS",
      },
      {
        label: "IVA $",
        field: "iva",
      },
      {
        label: "IVA BS",
        field: "ivaBS",
      },
      {
        label: "Total $",
        field: "monto",
      },
      {
        label: "Total BS",
        field: "montoBS",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Titular",
        field: "titular",
      },
      {
        label: "Titular rif",
        field: "rifTitular",
      },
      {
        label: "Nro. Cobro",
        field: "nroCobro",
      },
      {
        label: "Facturas",
        field: "facturas",
      },
      {
        label: "Factura Fiscal",
        field: "facturaFiscal",
      },
      {
        label: "Tasa Fiscal",
        field: "tasaFiscal",
      },
      {
        label: "Descripción",
        field: "descripcion",
      },
      {
        label: "Comentario Valija",
        field: "comentValija",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    pagination: {
      sortBy: 'fechaC', // The field that you're sorting by
      descending: true,
      page: 1,
      rowsPerPage: 25,
    },
    paginationMov: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    modal2: false,
    search: "",
    form: {
      _id: "",
      nro: "",
      nroCobro: "",
      nroCobro2: "",
      procesado2: false,
      titular: "",
      moneda: "",
      tasa: "",
      tasaIva: "",
      rifTitular: "",
      nroAJNM: "",
      nroADEL: "",
      nroNI: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: 0,
      iva: 0,
      base: 0,
      tipo: "",
      referencia: "",
      descripcion: "",
      bauche: "",
      metodo: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headersMov: [
      { text: "Check", value: "check" },
      { text: "Fecha", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" }
    ],
    headers: [
      { text: "Check", value: "check" },
      { text: "Nro", value: "nro" },
      { text: "Grupo", value: "groupCobro" },
      { text: "Fecha", value: "fechaC" },
      { text: "Fecha de pago", value: "fechaP" },
      { text: "Moneda", value: "moneda" },
      { text: "Tasa B.", value: "tasa" },
      { text: "Tasa I.", value: "tasaIva" },
      { text: "N° Valija", value: "nroValija" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "clienteN" },
      { text: "Método", value: "metodo" },
      { text: "Monto", value: "monto" },
      { text: "Tipo", value: "iva" },
      { text: "Referencia", value: "referencia" },
      { text: "Nro. Cobro", value: "nroCobro" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción", value: "accion" }
    ],
    defaultForm: {
      _id: "",
      nro: "",
      nroCobro: "",
      nroCobro2: "",
      procesado2: false,
      titular: "",
      rifTitular: "",
      vendedor: "",
      nroADEL: "",
      nroNI: "",
      moneda: "",
      tasa: "",
      tasaIva: "",
      nroAJNM: "",
      cliente: {},
      facturas: [],
      monto: 0,
      iva: 0,
      base: 0,
      tipo: "",
      descripcion: "",
      referencia: "",
      bauche: "",
      metodo: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    facturaFiscalTexto() {
      const fiscales = (this.itemsF || [])
        .filter(i => i.factura_fiscal)
        .map(i => {
          const tasa = i.tasa_fiscal != null ? ` (Tasa: ${i.tasa_fiscal} BS)` : '';
          return `#${i.factura_fiscal}${tasa}`;
        });
      return fiscales.join(', ');
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    validarIva() {
      let bool = true;
      this.selected.forEach(el=>{
        if (el.tipo == "IVA") bool = false;
      })
      return bool;
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    selected(val) {
      if (val.length > 1) {
        const primerEstatus = val[0].estatus; // Obtener el estatus del primer registro
        for (let i = val.length - 1; i >= 0; i--) {
          if (val[i].estatus !== primerEstatus) {
            this.$swal.fire({
              position: "top-end",
              icon: "error",
              html: "<span style='font-size:20px;'>El registro con estatus "+this.selected[i].estatus+" no coincide los anteriores</span>",
              showConfirmButton: false,
              timer: 1500
            });
            this.selected.splice(i, 1);
          }
        }
      }
    },
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    "form.fechaP": function(val) {
      if (val && this.dialog9) {
        this.dateFormatted = this.formatDate(this.form.fechaP)
      }
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    esMetodoP2(metodo) {
      const metodoLimpio = (metodo || "").trim();
      console.log(metodoLimpio)
      return [
        "Transferencia Internacional Banesco Panamá",
        "Transferencia Nacional Banesco",
        "Transferencia Nacional Bancaribe",
        "Transferencia Nacional Mercantil",
        "Transferencia Nacional Provincial"
      ].includes(metodoLimpio);
    },
    reversarConciliacion(item) {
      this.dialog4 = true;
      let info = {
        _id: item._id,
        referencia: item.referenciaOld ? item.referenciaOld : item.referencia,
        referenciaOld: null,
        estatus: "Pendiente"
      }
      info.usuario = this.$store.state.adminfercoven._id
      info.accion = 'Reverso de conciliacion, Nro: '+item.nro
      Api.put("cobros/reversarConciliacion", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.dialog4 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
        })
        .catch(err => {
          console.log(err);
          this.dialog4 = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    close4() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog6 = false;
    },
    close3() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog3 = false;
    },
    imprimirPdf () {
      printJS({
        printable: 'printJS-form',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        style: '@page { size: Letter landscape; }',
        css: 'printPdf'
      })
    },
    imprimirPdf2 () {
      printJS({
        printable: 'printJS-form2',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        style: '@page { size: Letter portrait; }',
        css: 'printPdf'
      })
    },
    transformMontoG(item) {
      if (item.tasa && item.tasaIva) {
        return ((parseFloat(item.base) / parseFloat(item.tasa))+(parseFloat(item.iva) / parseFloat(item.tasaIva))).toFixed(2)
      } else if (item.tasa && item.base) {
        return parseFloat((parseFloat(item.base) / parseFloat(item.tasa)).toFixed(2))
      } else return parseFloat(item.monto)
    },
    transformMonto(monto, tasa) {
      if (tasa) {
        return parseFloat((parseFloat(monto) / parseFloat(tasa)).toFixed(2))
      } else return parseFloat(monto)
    },
    formatearFacturasExcel(el) {
      const facturasList = [];
      const fiscalesList = [];
      const tasasFiscalesList = [];

      const raw = (el && el.facturas) ? el.facturas : [];
      for (let j = 0; j < raw.length; j++) {
        let f = raw[j];
        if (typeof f === 'string') {
          try {
            f = JSON.parse(f);
          } catch (_) {
            f = { nro_doc: f };
          }
        }
        if (f) {
          const nroDoc = (f.nro_doc || f.nro || f).toString().trim();
          if (nroDoc && !facturasList.includes(nroDoc)) facturasList.push(nroDoc);

          if (f.factura_fiscal) {
            let fisc = f.factura_fiscal.toString().trim();
            if (fisc.startsWith('#')) fisc = fisc.substring(1);
            if (fisc && !fiscalesList.includes(`#${fisc}`)) {
              fiscalesList.push(`#${fisc}`);
              if (f.tasa_fiscal != null && f.tasa_fiscal !== '') {
                tasasFiscalesList.push(f.tasa_fiscal);
              }
            }
          }
        }
      }

      return {
        facturas: facturasList.length > 0 ? facturasList.join(', ') : 'N/A',
        facturaFiscal: fiscalesList.length > 0 ? fiscalesList.join(', ') : 'N/A',
        tasaFiscal: tasasFiscalesList.length > 0 ? tasasFiscalesList.join(', ') : 'N/A'
      };
    },
    filterPerfectMatch(items, search, filter) {
      let inf = items
      search = search.toString().toLowerCase();
      if (search.trim() === '') {
        if (inf && inf.length > 0) {
          this.dataExcel = []
          for (let i = 0; i < inf.length; i++) {
            const el = inf[i];
            const factInfo = this.formatearFacturasExcel(el);
            this.dataExcel.push({
              _id: el._id,
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
              moneda: (el.moneda) ? el.moneda : "N/A",
              tasa: (el.tasa) ? el.tasa : "N/A",
              tasaIva: (el.tasaIva) ? el.tasaIva : "N/A",
              nroValija: (el.nroValija) ? el.nroValija : "N/A",
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: el.metodo,
              tipo: el.tipo ? el.tipo : "N/A",
              base: (el.base && el.moneda == "BS" && el.tasa) ? this.transformMonto(el.base, el.tasa) : (el.base && el.moneda == "US$") ? el.base : "N/A",
              baseBS: (el.base && el.moneda == "BS") ? el.base : 0,
              iva: (typeof el.iva == "number" && el.moneda == "BS" && el.tasaIva) ? this.transformMonto(el.iva, el.tasaIva) : (typeof el.iva == "number" && el.moneda == "US$") ? el.iva : "N/A",
              ivaBS: (typeof el.iva == "number" && el.moneda == "BS") ? el.iva : 0,
              monto: (el.moneda == "BS" && el.tasa) ? this.transformMontoG(el) : (el.moneda == "US$") ? el.monto : "N/A",
              montoBS: (el.moneda == "BS") ? el.monto : 0,
              referencia: (el.referencia) ? el.referencia : "N/A",
              titular: (el.titular) ? el.titular : "N/A",
              rifTitular: (el.rifTitular) ? el.rifTitular : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: factInfo.facturas,
              facturaFiscal: factInfo.facturaFiscal,
              tasaFiscal: factInfo.tasaFiscal,
              descripcion: el.descripcion,
              comentValija: (el.comentValija) ? el.comentValija : "N/A",
              estatus: el.estatus
            })
          }
        }
        return items;
      }
      inf = items.filter(function (i) {
          return Object.keys(i).some(function (j) {
              return filter(i[j], search);
          });
      });
      if (inf && inf.length > 0) {
        this.dataExcel = []
        for (let i = 0; i < inf.length; i++) {
          const el = inf[i];
          const factInfo = this.formatearFacturasExcel(el);
          this.dataExcel.push({
            _id: el._id,
            nro: el.nro,
            fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
            fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
            moneda: (el.moneda) ? el.moneda : "N/A",
            tasa: (el.tasa) ? el.tasa : "N/A",
            tasaIva: (el.tasaIva) ? el.tasaIva : "N/A",
            nroValija: (el.nroValija) ? el.nroValija : "N/A",
            vendedor: el.vendedor,
            cliente: el.cliente.cli_des,
            metodo: el.metodo,
            tipo: el.tipo ? el.tipo : "N/A",
            base: (el.moneda == "BS" && el.tasa) ? this.transformMonto(el.base, el.tasa) : (el.moneda == "US$") ? el.base : "N/A",
            baseBS: (el.moneda == "BS") ? el.base : 0,
            iva: (el.moneda == "BS" && el.tasaIva) ? this.transformMonto(el.iva, el.tasaIva) : (el.moneda == "US$") ? el.iva : "N/A",
            ivaBS: (el.moneda == "BS") ? el.iva : 0,
            monto: (el.moneda == "BS" && el.tasa) ? this.transformMontoG(el) : (el.moneda == "US$") ? el.monto : "N/A",
            montoBS: (el.moneda == "BS") ? el.monto : 0,
            referencia: (el.referencia) ? el.referencia : "N/A",
            titular: (el.titular) ? el.titular : "N/A",
            rifTitular: (el.rifTitular) ? el.rifTitular : "N/A",
            nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
            facturas: factInfo.facturas,
            facturaFiscal: factInfo.facturaFiscal,
            tasaFiscal: factInfo.tasaFiscal,
            descripcion: el.descripcion,
            comentValija: (el.comentValija) ? el.comentValija : "N/A",
            estatus: el.estatus
          })
        }
      }
      return inf
    },
    transform2(date) {
      return this.$moment(date).format("DD/MM/YYYY H:mm A")
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    aplicarFiltros() {
      let filtroM = this.seleccionFiltroM;
      let filtroE = this.seleccionFiltro;

      this.resultados = []
      this.resultados = this.resultadosres.filter(el => {
        const cumpleFiltroB = (filtroM === "todos" || el.metodo === filtroM);
        const cumpleFiltroE = (filtroE === "todos" || el.estatus === filtroE);
        return cumpleFiltroB && cumpleFiltroE;
      });
      if (this.resultados && this.resultados.length > 0) {
        this.$nextTick(() => {
          for (let i = 0; i < this.resultados.length; i++) {
            let el = this.resultados[i];
            el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
          }
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminfercoven.permisos.length; i++) {
        if (this.$store.state.adminfercoven.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.adminfercoven.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminfercoven.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminfercoven.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminfercoven.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        this.dialog4 = true
        this.selected = [];
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = []
        this.seleccionFiltro = "todos"
        this.seleccionFiltroM = "todos"
        this.search = ""
        Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(async res => {
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const el = res.data[i];
              if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
              let fact = []
              for (let j = 0; j < (el.facturas || []).length; j++) {
                const el2 = el.facturas[j];
                if (typeof el2 === "string") {
                  try {
                    const parsed = JSON.parse(el2);
                    if (Array.isArray(parsed)) fact.push(...parsed);
                    else fact.push(parsed);
                  } catch (_) {
                    fact.push({ nro_doc: el2 });
                  }
                } else fact.push(el2)
              }
              el.coincide = false;
              el.facturas = fact
              el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
              this.resultados.push(el)
              this.resultadosres.push(el)
            }
            await this.cargarFiscalesCobros(this.resultados);
          }
          this.dialog4 = false
          this.buscarTodosMov()
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    buscarTodosMov() {
      Api.get(`movimientos/pendientes`).then(res => {
        this.resultadosMovAll = res.data;
        this.resultadosres.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodo &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
        this.resultados.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodo &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
      })
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      this.dataExcel2 = []
      this.dialog4 = true;
      Api.get("cobros/adminReporte").then(res => {
        this.resultados2 = []
        if (res.data && res.data.length > 0) {
          this.resultados2 = res.data
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.dataExcel2.push({
              fecha: this.$moment(el.fecha).utc().format('DD-MM-YYYY H:mm A'),
              co_ven: el.co_ven,
              ven_des: el.ven_des,
              total: el.total
            })
          }
        }
      }).catch(err=>{
        console.log(err)
      });
      Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(async res => {
        this.resultados = []
        this.resultadosres = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let j = 0; j < (el.facturas || []).length; j++) {
              const el2 = el.facturas[j];
              if (typeof el2 === "string") {
                try {
                  const parsed = JSON.parse(el2);
                  if (Array.isArray(parsed)) fact.push(...parsed);
                  else fact.push(parsed);
                } catch (_) {
                  fact.push({ nro_doc: el2 });
                }
              } else fact.push(el2)
            }
            el.coincide = false;
            el.facturas = fact
            el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
            this.resultados.push(el)
            this.resultadosres.push(el)
          }
          await this.cargarFiscalesCobros(this.resultados);
        }
        this.dialog4 = false;
        this.buscarTodosMov()
      }).catch(err=>{
        this.dialog4 = false;
        console.log(err)
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    async consultarFiscalesCobro(facturasNros, item) {
      if (!facturasNros || facturasNros.length === 0) return;
      try {
        const res = await Api.post('facturafiscal/consultar-fiscales', { facturas: facturasNros });
        if (res && res.data && Array.isArray(res.data)) {
          res.data.forEach(info => {
            if (info && info.nro_doc && info.factura_fiscal) {
              const fiscalTrim = info.factura_fiscal.toString().trim();
              const tasaFiscal = info.tasa_fiscal != null ? info.tasa_fiscal : null;
              const found = this.itemsF.find(it => it.value === info.nro_doc.trim());
              if (found) {
                found.factura_fiscal = fiscalTrim;
                found.tasa_fiscal = tasaFiscal;
                const tasaStr = tasaFiscal != null ? ` - Tasa: ${tasaFiscal} BS` : '';
                found.text = `${info.nro_doc.trim()} (Fiscal: #${fiscalTrim}${tasaStr})`;
              }
              if (item && item.facturas) {
                item.facturas.forEach(f => {
                  if (typeof f === 'object' && f && f.nro_doc && f.nro_doc.trim() === info.nro_doc.trim()) {
                    f.factura_fiscal = fiscalTrim;
                    if (tasaFiscal != null) f.tasa_fiscal = tasaFiscal;
                  }
                });
              }
            }
          });
        }
      } catch (err) {
        console.error('Error al consultar facturas fiscales:', err);
      }
    },
    async cargarFiscalesCobros(cobros) {
      if (!cobros || cobros.length === 0) return;
      const facturasNros = [];
      cobros.forEach(c => {
        (c.facturas || []).forEach(f => {
          const doc = (f && (f.nro_doc || f.nro || f) ? (f.nro_doc || f.nro || f) : '').toString().trim();
          if (doc && !facturasNros.includes(doc)) {
            facturasNros.push(doc);
          }
        });
      });

      if (facturasNros.length === 0) return;

      try {
        const res = await Api.post('facturafiscal/consultar-fiscales', { facturas: facturasNros });
        if (res && res.data && Array.isArray(res.data)) {
          const mapa = {};
          res.data.forEach(info => {
            if (info && info.nro_doc && info.factura_fiscal) {
              mapa[info.nro_doc.toString().trim()] = {
                factura_fiscal: info.factura_fiscal.toString().trim(),
                tasa_fiscal: info.tasa_fiscal != null ? info.tasa_fiscal : null
              };
            }
          });

          cobros.forEach(c => {
            (c.facturas || []).forEach(f => {
              if (typeof f === 'object' && f) {
                const doc = (f.nro_doc || f.nro || '').toString().trim();
                if (mapa[doc]) {
                  f.factura_fiscal = mapa[doc].factura_fiscal;
                  if (mapa[doc].tasa_fiscal != null) {
                    f.tasa_fiscal = mapa[doc].tasa_fiscal;
                  }
                }
              }
            });
          });

          this.filterPerfectMatch(this.resultados, this.search || '', () => true);
        }
      } catch (err) {
        console.error('Error al cargar fiscales para cobros:', err);
      }
    },
    async editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = [];
      this.form.facturas = [];
      const facturasRaw = item.facturas || [];
      const facturasNros = [];

      for (let i = 0; i < facturasRaw.length; i++) {
        let el = facturasRaw[i];
        if (typeof el === 'string') {
          try {
            el = JSON.parse(el);
          } catch (_) {
            el = { nro_doc: el };
          }
        }
        const nroDoc = (el && (el.nro_doc || el) ? (el.nro_doc || el) : '').toString().trim();
        const fiscal = el && el.factura_fiscal ? el.factura_fiscal.toString().trim() : null;
        const tasaFiscal = el && el.tasa_fiscal != null ? el.tasa_fiscal : null;
        let text = nroDoc;
        if (fiscal) {
          const tasaStr = tasaFiscal != null ? ` - Tasa: ${tasaFiscal} BS` : '';
          text = `${nroDoc} (Fiscal: #${fiscal}${tasaStr})`;
        }
        this.itemsF.push({
          value: nroDoc,
          text: text,
          factura_fiscal: fiscal,
          tasa_fiscal: tasaFiscal
        });
        this.form.facturas.push(nroDoc);
        if (nroDoc) facturasNros.push(nroDoc);
      }
      this.form._id = item._id;
      this.dialog = true;

      await this.consultarFiscalesCobro(facturasNros, item);
    },
    async editItemPdf(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = [];
      this.form.facturas = [];
      const facturasRaw = item.facturas || [];
      const facturasNros = [];

      for (let i = 0; i < facturasRaw.length; i++) {
        let el = facturasRaw[i];
        if (typeof el === 'string') {
          try {
            el = JSON.parse(el);
          } catch (_) {
            el = { nro_doc: el };
          }
        }
        const nroDoc = (el && (el.nro_doc || el) ? (el.nro_doc || el) : '').toString().trim();
        const fiscal = el && el.factura_fiscal ? el.factura_fiscal.toString().trim() : null;
        const tasaFiscal = el && el.tasa_fiscal != null ? el.tasa_fiscal : null;
        let text = nroDoc;
        if (fiscal) {
          const tasaStr = tasaFiscal != null ? ` - Tasa: ${tasaFiscal} BS` : '';
          text = `${nroDoc} (Fiscal: #${fiscal}${tasaStr})`;
        }
        this.itemsF.push({
          value: nroDoc,
          text: text,
          factura_fiscal: fiscal,
          tasa_fiscal: tasaFiscal
        });
        this.form.facturas.push(nroDoc);
        if (nroDoc) facturasNros.push(nroDoc);
      }
      this.form._id = item._id;
      this.dialog6 = true;

      await this.consultarFiscalesCobro(facturasNros, item);
    },
    editItemReferencia(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog8 = true;
    },
    close9() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog9 = false;
    },
    editItemFecha(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.form.fechaP = this.$moment(this.form.fechaP).utc().format('YYYY-MM-DD')
      this.dateFormatted = this.formatDate(this.$moment(this.form.fechaP).utc().format('YYYY-MM-DD'))
      this.dialog9 = true;
    },
    editItemMonto(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog5 = true;
    },
    saveFecha() {
      let info = {
        _id: this.form._id,
        fechaP: this.form.fechaP
      }
      this.loading = true;
      info.usuario = this.$store.state.adminfercoven._id
      info.accion = 'Modificación de fecha, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog9 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    saveMonto() {
      let info = {
        _id: this.form._id,
        monto: 0
      }
      if (this.form.base) {
        info.base = parseFloat(this.form.base)
        info.monto += parseFloat(this.form.base)
      }
      if (this.form.iva) {
        info.iva = parseFloat(this.form.iva)
        info.monto += parseFloat(this.form.iva)
      }
      if (this.form.tasa) info.tasa = parseFloat(this.form.tasa)
      if (this.form.tasaIva) info.tasaIva = parseFloat(this.form.tasaIva)
      this.loading = true;
      info.usuario = this.$store.state.adminfercoven._id
      info.accion = 'Modificación de montos, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.iva) el.iva = info.iva
              if (info.tasa) el.tasa = info.tasa
              if (info.tasaIva) el.tasaIva = info.tasaIva
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.iva) el.iva = info.iva
              if (info.tasa) el.tasa = info.tasa
              if (info.tasaIva) el.tasaIva = info.tasaIva
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.iva) el.iva = info.iva
              if (info.tasa) el.tasa = info.tasa
              if (info.tasaIva) el.tasaIva = info.tasaIva
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog5 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    closeMonto() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog5 = false;
    },
    registrarIVA(item) {
        this.$swal.fire({
          title: 'Ingrese el nro de registro',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            let info = {
              _id: item._id,
              nroCobro: result.value,
              estatus: "Registrado"
            }
            this.dialog4 = true;
            info.usuario = this.$store.state.adminfercoven._id
            info.accion = 'Registrar IVA, Nro: '+item.nro
            Api.put("cobros", info)
              .then(() => {
                this.resultados.forEach(el=>{
                  if (el._id.toString() == info._id.toString()) {
                    el.estatus = info.estatus
                    el.nroCobro = info.nroCobro
                  }
                })
                this.resultadosres.forEach(el=>{
                  if (el._id.toString() == info._id.toString()) {
                    el.estatus = info.estatus
                    el.nroCobro = info.nroCobro
                  }
                })
                this.dataExcel.forEach(el=>{
                  if (el._id.toString() == info._id.toString()) {
                    el.estatus = info.estatus
                    el.nroCobro = info.nroCobro
                  }
                })
                this.$nextTick(() => {
                  this.$swal.fire(
                    "Felicidades.!",
                    "Modificación realizada exitosamente.",
                    "success"
                  );
                  this.dialog4 = false;
                })
              })
              .catch(err => {
                console.log(err);
                this.dialog4 = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
    },
    saveRef() {
      let info = {
        _id: this.form._id,
        referencia: this.form.referencia,
        metodo: this.form.metodo
      }
      this.loading = true;
      info.usuario = this.$store.state.adminfercoven._id
      info.accion = 'Modificación de referencia, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog8 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          const errorMessage = err.response && err.response.data && err.response.data.error || err.message || 'Error desconocido';
          this.$swal.fire(
            "Oops...",
            errorMessage,
            "error"
          );
      });
    },
    closeRef() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog8 = false;
    },
    closeMov() {
      this.itemMov = null;
      this.typeMov = null;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = false;
    },
    buscarMovAso(item, type) {
      this.itemMov = item;
      this.typeMov = type;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = true;
      this.dialog4 = true;
      Api.get(`movimientos/coincidencias?fecha=${item.fechaP}&banco=${item.metodo}&monto=${item.monto}&ref=${item.referencia}`).then(res => {
        this.resultadosMov = res.data;
        this.dialog4 = false;
      }).catch(err=>{
        console.log(err)
        this.$swal.fire(
          "¡Atención!",
          err,
          "error"
        );
        this.dialog4 = false;
      });
    },
    editItemAproMov() {
      if (this.selectMov && this.selectMov.length > 0) {
        Object.keys(this.form).map(key => {
          if (this.itemMov[key]) this.form[key] = this.itemMov[key];
        });
        this.itemsF = []
        this.form.facturas = []
        for (let i = 0; i < this.itemMov.facturas.length; i++) {
          const el = this.itemMov.facturas[i];
          this.itemsF.push({
            value: el.nro_doc,
            text: el.nro_doc
          })
          this.form.facturas.push(el.nro_doc)
        }
        this.form._id = this.itemMov._id;
        this.save(this.typeMov, this.selectMov)
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debe seleccionar un movimiento para continuar",
          "error"
        );
      }
    },
    editItemApro(item, type) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.save(type)
    },
    actualizarEstatusYObservacion(array, selected, info) {
      selected.forEach(el2 => {
        const match = array.find(el => el._id.toString() === el2._id.toString());
        if (match) {
          if (info.estatus) match.estatus = info.estatus;
          if(info.observacion) match.observacion = info.observacion;
          if (info.profit2) match.profit2 = info.profit2;
          if (info.procesado2) match.procesado2 = info.procesado2;
        }
      });
    },
    saveAll(item) {
      let newArry = [];
      let nros = ''
      let seleccion = this.selected;
      if (item === "P2") {
        seleccion = this.selected.filter(el => this.esMetodoP2(el.metodo) && !el.procesado2);
        if (seleccion.length === 0) {
          this.$swal.fire(
            "¡Atención!",
            "Ninguno de los cobros seleccionados aplica para Procesar 2.",
            "error"
          );
          return;
        }
        if (seleccion.length < this.selected.length) {
          this.$swal.fire(
            "Atención",
            "Se omitieron " + (this.selected.length - seleccion.length) + " cobro(s) que no aplican a Procesar 2.",
            "info"
          );
        }
      }
      for (let i = 0; i < seleccion.length; i++) {
        let el = seleccion[i];
        if (i !== (i < seleccion.length - 1)) {
            nros += el.nro+', '
        } else nros += el.nro
        if (item === "P") {
          el.profit = true
          el.estatus = "Procesado"
        } else if (item === "P2") {
          el.profit2 = true
        } else el.estatus = (item === "A") ? "Aprobado" : "Rechazado"
        newArry.push({
          _id: el._id,
          profit: el.profit,
          profit2: el.profit2,
          procesado2: el.procesado2,
          usuario: this.$store.state.adminfercoven._id,
          accion: item === "P2" ? 'Procesar 2 (BD secundaria) por lote' : ('Modificación de estatus por lote ('+el.estatus+')'),
          estatus: el.estatus
        })
      }
      newArry[0].accion = newArry[0].accion+', Nros:'+nros
      if (newArry[0].estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            for (let i = 0; i < newArry.length; i++) {
              let el = newArry[i];
              el.observacion = result.value
            }
            this.dialog4 = true;
            Api.put("cobros/all", newArry)
              .then(() => {
                this.actualizarEstatusYObservacion(this.resultados, newArry, newArry[0]);
                this.actualizarEstatusYObservacion(this.resultadosres, newArry, newArry[0]);
                this.actualizarEstatusYObservacion(this.dataExcel, newArry, newArry[0]);
                this.$nextTick(() => {
                  this.selected = [];
                  this.$swal.fire(
                    "Felicidades.!",
                    "Modificación realizada exitosamente.",
                    "success"
                  );
                  this.dialog4 = false;
                })
              })
              .catch(err => {
                console.log(err);
                this.dialog4 = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.dialog4 = true;
        Api.put("cobros/all", newArry)
          .then(() => {
            this.actualizarEstatusYObservacion(this.resultados, newArry, newArry[0]);
            this.actualizarEstatusYObservacion(this.resultadosres, newArry, newArry[0]);
            this.actualizarEstatusYObservacion(this.dataExcel, newArry, newArry[0]);
            this.$nextTick(() => {
              this.selected = [];
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              this.dialog4 = false;
            })
          })
          .catch(err => {
            console.log(err);
            this.dialog4 = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    },
    save(item, mov = null) {
      let info
      if (item === "F") {
        info = {
          _id: this.form._id,
          estatus: "Finalizado"
        }
      } else if (item === "P") {
        info = {
          _id: this.form._id,
          profit: true,
          referencia: this.form.referencia,
          estatus: "Procesado"
        }
      } else if (item === "P2") {
        info = {
          _id: this.form._id,
          profit2: true
        }
      } else if (item == "A" || item == "R") {
        info = {
          _id: this.form._id,
          referencia: this.form.referencia,
          mov: mov && mov.length > 0 ? mov[0] : null,
          estatus: (item === "A") ? "Aprobado" : "Rechazado"
        }
      } else {
        info = {
          _id: this.form._id,
          referencia: mov && mov.length > 0 ? mov[0].referencia : this.form.referencia,
          referenciaOld: mov && mov.length > 0 ? this.form.referencia : null,
          mov: mov && mov.length > 0 ? mov[0] : null,
          estatus: "Conciliado"
        }
      }
      if (info.estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            info.observacion = result.value
            info.usuario = this.$store.state.adminfercoven._id
            info.accion = 'Modificación de estatus (Rechazado), Nro: '+this.form.nro
            this.loading = true;
            Api.put("cobros", info)
              .then(() => {
                this.resultados.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.resultadosres.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.dataExcel.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.loading = true;
        info.usuario = this.$store.state.adminfercoven._id
        info.accion = info.estatus ? 'Modificación de estatus ('+info.estatus+'), Nro: '+this.form.nro : 'Procesar 2 (BD secundaria), Nro: '+this.form.nro
        Api.put("cobros", info)
          .then(() => {
            this.closeMov();
            this.resultados.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                if (info.estatus) el.estatus = info.estatus
                if (info.profit2) el.profit2 = info.profit2
                if (info.procesado2) el.procesado2 = info.procesado2
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.resultadosres.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                if (info.estatus) el.estatus = info.estatus
                if (info.profit2) el.profit2 = info.profit2
                if (info.procesado2) el.procesado2 = info.procesado2
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.dataExcel.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                if (info.estatus) el.estatus = info.estatus
                if (info.profit2) el.profit2 = info.profit2
                if (info.procesado2) el.procesado2 = info.procesado2
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    }
  }
};
</script>
<style lang="scss">
.v-datatable__actions__select {
  display: none;
}
table.v-table tbody td, table.v-table tbody th {
  height: auto;
}
</style>
